import React from 'react';
import Loadable from 'react-loadable';

const SearchKitVNL = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default SearchKitVNL;
